import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';

let initialized = false;

/**
 * Initialize i18n with the given ACD locale code (e.g. 'enUS', 'esUS', 'frFR').
 * Safe to call multiple times — subsequent calls only change the language.
 */
export function initI18n(locale: string = 'en'): void {
  const lng = locale.slice(0, 2); // 'enUS' → 'en', 'esUS' → 'es', 'frFR' → 'fr'

  if (!initialized) {
    i18n.use(initReactI18next).init({
      resources: {
        en: { translation: en },
        es: { translation: es },
        fr: { translation: fr },
      },
      lng,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
    });
    initialized = true;
  } else if (i18n.language !== lng) {
    i18n.changeLanguage(lng);
  }
}
